import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./context/authContext";
import { useOptions } from "./context/optionContext";
import { ROUTES } from "./constants";

const normalizeBoolean = (value, fallback = false) => {
	if (typeof value === "boolean") return value;
	if (typeof value === "number") return value === 1;
	if (typeof value === "string") {
		const normalized = value.trim().toLowerCase();
		if (normalized === "true" || normalized === "1" || normalized === "yes") return true;
		if (normalized === "false" || normalized === "0" || normalized === "no") return false;
	}
	return fallback;
};

const SpecialProtectedRoute = () => {
	const { isAuthenticated, user, sendOtp } = useAuth();
	const location = useLocation();
	const [otpSent, setOtpSent] = useState(false);
	const { mfaDays, mfaEnabled } = useOptions();
	// const handleSendOTP = async () => {
	// 	if (needsEmailVerification && !otpSent) {
	// 		await sendOtp(user.user_id);
	// 		setOtpSent(true);
	// 	}
	// };

	// If not authenticated at all, redirect to login
	if (!isAuthenticated) {
		return <Navigate to={ROUTES.LOGIN} replace />;
	}
	if (isAuthenticated && !user.eula_accepted) {
		
		return <Navigate to={ROUTES.ACCEPT_EULA} replace />;
	}

	const daysWindow = Number(mfaDays) || 0;
	const lastVerified = user?.email_verified_date ? new Date(user.email_verified_date) : null;
	const hasValidVerificationDate =
		lastVerified instanceof Date && !Number.isNaN(lastVerified.getTime());

	const firstLoginRequiresVerification = normalizeBoolean(user?.first_login, false);
	const emailVerified = normalizeBoolean(user?.email_verified, false);

	const verificationExpired =
		Boolean(mfaEnabled) &&
		daysWindow > 0 &&
		(!hasValidVerificationDate ||
			Date.now() - lastVerified.getTime() > daysWindow * 24 * 60 * 60 * 1000);

	const requiresOtp = isAuthenticated && (firstLoginRequiresVerification || !emailVerified || verificationExpired);

	if (requiresOtp) {
		return <Navigate to={ROUTES.VERIFY_EMAIL} replace />;
	}

	return <Outlet />;
};

export default SpecialProtectedRoute;
